import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { createTeamRequest } from './api.create-team.request.js';
import { getTeamsQuery } from './api.get-teams.query.js';
import { createLocalTeam } from './util.create-local-team.js';

function useCreateTeamMutation() {
  const client = useQueryClient();
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  return useMutation(createTeamMutation(client, notifier, user));
}
/**
 * Creates a team optimisticly and reverts in case anything fails on the
 * backend.
 */
const createTeamMutation = (client, notifier, user) => {
  return {
    mutationKey: ["user-area/teams/create", user?.id],
    mutationFn: newTeam => createTeamRequest(user, newTeam),
    onMutate: async input => {
      const optimistic = createLocalTeam(input);
      client.setQueryData(getTeamsQuery.queryKey({
        user
      }), previous => [...(previous ?? []), optimistic]);
      await client.cancelQueries({
        queryKey: getTeamsQuery.queryKey({
          user
        })
      });
      return {
        optimistic
      };
    },
    onSuccess: (result, _, context) => {
      notifier.notify({
        id: "user-area.teams.create",
        type: "success",
        body: "Holdet er blevet oprettet."
      });
      client.setQueryData(getTeamsQuery.queryKey({
        user
      }), previous => previous?.map(course => course.key === context?.optimistic.key ? result : course));
    },
    onError: (error, _, context) => {
      notifier.notify({
        id: "user-area.teams.error",
        type: "error",
        body: "Holdet kunne ikke oprettes. Prøv igen om lidt."
      });
      client.setQueryData(getTeamsQuery.queryKey({
        user
      }), previous => previous?.filter(course => course.key !== context?.optimistic.key));
    }
  };
};

export { useCreateTeamMutation };
//# sourceMappingURL=api.create-team.mutation.js.map
